// Central destinations for the marketing CTAs.

// Every "Start Free" button links here. Defaults to the built-in /start-free
// application page; override with VITE_START_FREE_URL to point elsewhere
// (e.g. an external self-serve signup).
export const START_FREE_URL = import.meta.env.VITE_START_FREE_URL || '/start-free';

// True when START_FREE_URL points off-site (so links open in a new tab).
export const START_FREE_EXTERNAL = /^https?:\/\//.test(START_FREE_URL);

// Shared destinations for the 2026 site (Hub + product pages).
export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL || 'info@fbinsights.com';
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
export const CALENDAR_URL = 'https://calendar.app.google/92q4HZS9L4m1TTkz7';
